import { ReactNode } from 'react';

import Paper from '@mui/material/Paper';

interface AgreementContainerProps {
  children: ReactNode;
}

export function AgreementContainer({ children }: AgreementContainerProps) {
  return (
    <Paper
      variant="outlined"
      sx={{
        my: 2,
        px: 2,
        py: 4,
      }}
    >
      {children}
    </Paper>
  );
}

export default AgreementContainer;
